import { Button, Popover, Stack, TextField } from "@mui/material";
import type { ChangeEvent, KeyboardEvent } from "react";
import { useState } from "react";
import type { ObserverIssueInfo } from "../../../api/observerTypes";

interface Props {
  anchorEl: HTMLElement;
  issue: ObserverIssueInfo;
  onSave: (issue: ObserverIssueInfo, githubIssueNumber?: string) => void;
  onClose: () => void;
}

const ObserverGithubNumberPopover = ({ anchorEl, issue, onSave, onClose }: Props) => {
  const [value, setValue] = useState(issue.githubIssueNumber ?? "");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value.replace(/\D/g, ""));
  };

  const handleSave = () => {
    onSave(issue, value.trim() || undefined);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    }
  };

  return (
    <Popover
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Stack spacing={1.5} sx={{ width: 280, p: 1.5 }}>
        <TextField
          label="GitHub issue number"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoFocus
          fullWidth
          slotProps={{ htmlInput: { inputMode: "numeric" } }}
        />
        <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
          <Button variant="text" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Stack>
      </Stack>
    </Popover>
  );
};

export default ObserverGithubNumberPopover;
